import { createLogger } from "redux-logger";

const logger = createLogger({
  // ...options
});

// Disable logger completely (set to false to enable in development)
const loggerMiddleware = false
  ? logger
  : () => (next: any) => (action: any) => next(action);

export default loggerMiddleware;
